import { styled } from '@material-ui/core';
import { Events, Linked } from '@type-r/models';
import * as queryString from 'query-string';
export var colors = {
    green: '#01C38D',
    blue: '#0099E1',
    yellow: '#FFBC00',
    red: '#FF274B',
    grey: '#728A97',
    lightGrey: '#CBD9E3',
    orange: '#FFA500'
};
/**
 * Add markdown description to the storybook's story.
 */
export function description(story, markdown) {
    story.story = { parameters: { docs: { storyDescription: markdown } } };
}
function getPath() {
    return window.location.pathname.split('/');
}
export function getParamsFromPath(n) {
    if (n === void 0) { n = 2; }
    return getPath().slice(n);
}
export function getIdFromPath(n) {
    return getPath()[n];
}
export function useLinkedLocation(n, defaultValue, parent) {
    if (defaultValue === void 0) { defaultValue = ''; }
    if (parent === void 0) { parent = ''; }
    var value = getIdFromPath(n);
    if (!value && defaultValue) {
        navigate(value || getPath().includes(parent) ? defaultValue : parent + '/' + defaultValue, n);
    }
    return Linked.value(value || defaultValue, function (x) {
        if (x) {
            // TODO: Dirty hotfix for INM-307. Do it better.
            navigate(value || getPath().includes(parent) ? x : parent + '/' + x, n);
        }
        else {
            Events.trigger('navigate', getPath().slice(0, n).join('/'));
        }
    });
}
export function toLinkedBoolean(linked) {
    return Linked.value(Boolean(linked.value), function (x) {
        if (!x) {
            linked.null();
        }
    });
}
export function getBackPath() {
    var path = window.location.pathname.split('/');
    path.pop();
    return path.join('/');
}
export function back() {
    Events.trigger('navigate', getBackPath());
}
export function navigate(path, n, anchor, addReturnUrl) {
    if (n === void 0) { n = 2; }
    if (anchor === void 0) { anchor = undefined; }
    if (addReturnUrl === void 0) { addReturnUrl = false; }
    var params;
    if (addReturnUrl) {
        params = { returnUrl: "" + window.location.pathname + window.location.search };
    }
    Events.trigger('navigate', window.location.pathname.split('/').slice(0, n).join('/') + '/' + path, anchor, params);
}
export function jumpToAnchor(hash) {
    if (window.location.hash === '#' + hash) {
        window.location.hash = '';
    }
    window.location.hash = hash;
}
export var isEmbeddedApp = function () { return Boolean(window.location.pathname.match(/^\/\w*-app/)); };
export var getAppRoot = function () { return '/' + getIdFromPath(1); };
export var getAppHref = function (path) { return getAppRoot() + path; };
export var div = styled('div');
export var span = styled('span');
export function getQueryParam(key) {
    var parsed = queryString.parse(location.search);
    return parsed[key];
}
export function useLinkedQueryParam(key) {
    return Linked.value(getQueryParam(key), function (param) {
        var parsed = queryString.parse(location.search);
        if (param) {
            parsed[key] = param;
        }
        Events.trigger('navigate', window.location.pathname, null, parsed);
    });
}
//# sourceMappingURL=common.js.map